import { render, staticRenderFns } from "./home-bb.vue?vue&type=template&id=2d0a93f4&scoped=true"
import script from "./home-bb.vue?vue&type=script&lang=js"
export * from "./home-bb.vue?vue&type=script&lang=js"
import style0 from "./home-bb.vue?vue&type=style&index=0&id=2d0a93f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a93f4",
  null
  
)

export default component.exports